var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_1886)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_491_1886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33716 9.80279C8.93909 10.0682 8.47672 10.2085 8 10.2085C7.52331 10.2085 7.06094 10.0682 6.66288 9.80279L0.106531 5.43176C0.0701562 5.40751 0.0347187 5.38223 0 5.35623V12.5186C0 13.3398 0.666406 13.9915 1.47291 13.9915H14.5271C15.3482 13.9915 16 13.3251 16 12.5186V5.3562C15.9652 5.38226 15.9297 5.40761 15.8932 5.43189L9.33716 9.80279Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.626562 4.6518L7.18291 9.02286C7.43109 9.18833 7.71553 9.27105 7.99997 9.27105C8.28444 9.27105 8.56891 9.1883 8.81709 9.02286L15.3734 4.6518C15.7658 4.39039 16 3.95289 16 3.48071C16 2.6688 15.3395 2.0083 14.5276 2.0083H1.47241C0.660531 2.00833 0 2.66883 0 3.48149C0 3.95289 0.23425 4.39039 0.626562 4.6518Z",
    fill: "currentcolor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_1886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_491_1886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.337280b2d6d5226aca7647ce611c3c66.svg";
export { ForwardRef as ReactComponent };